import Home from 'views/home/Home';

export default Home;
